import Vue from 'vue';
import App from './App.vue';
import router from './router';
import Vconsole from "vconsole";
import {
    MessageBox,
    Indicator,
    Toast
} from 'mint-ui';
import 'mint-ui/lib/style.css';
import {
    install
} from './components';
import store from './store';

Vue.config.productionTip = false;
Vue.use(install);
Vue.prototype.$MessageBox = MessageBox;
Vue.prototype.$Indicator = Indicator;
Vue.prototype.$Toast = Toast;

window.globalVue = new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
// new Vconsole();